var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "modal-dialog modal-lg" }, [
    _c("div", { staticClass: "modal-content" }, [
      _c("div", { staticClass: "modal-header" }, [
        _c("h4", { staticClass: "modal-title" }, [_vm._v("Import CSV")]),
        _vm._v(" "),
        _c("button", {
          staticClass: "btn-close",
          attrs: { type: "button", "aria-label": "Close" },
          on: {
            click: function ($event) {
              return _vm.$emit("hide-modal")
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-body" },
        [
          _c(_setup.AttachmentDropzone, {
            staticClass: "mb-3",
            attrs: { "set-file": _setup.setFile },
          }),
          _vm._v(" "),
          _setup.state.loading
            ? _c("div", { staticClass: "mb-3 text-center" }, [
                _c("div", {
                  staticClass:
                    "spinner-border spinner-border-sm text-primary me-2",
                  attrs: { role: "status" },
                }),
                _vm._v("\n                Processing data…\n            "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_setup.state.notices, function (notice, index) {
            return [
              notice.heading
                ? _c(
                    "div",
                    { key: "n-card-" + index, staticClass: "mb-3 card" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "card-header bg-success-subtle text-success-emphasis d-flex align-items-center",
                        },
                        [
                          _c("i", {
                            staticClass: "bi bi-info-circle-fill me-2",
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: { innerHTML: _vm._s(notice.heading) },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "card-body",
                        domProps: { innerHTML: _vm._s(notice.message) },
                      }),
                    ]
                  )
                : _c("div", {
                    key: "n-alert-" + index,
                    staticClass: "alert alert-success",
                    domProps: { innerHTML: _vm._s(notice) },
                  }),
            ]
          }),
          _vm._v(" "),
          _vm._l(_setup.state.warnings, function (warning, index) {
            return [
              warning.heading
                ? _c(
                    "div",
                    { key: "w-card-" + index, staticClass: "mb-3 card" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "card-header bg-warning-subtle text-warning-emphasis d-flex align-items-center",
                        },
                        [
                          _c("i", {
                            staticClass: "bi bi-exclamation-triangle-fill me-2",
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: { innerHTML: _vm._s(warning.heading) },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "card-body",
                        domProps: { innerHTML: _vm._s(warning.message) },
                      }),
                    ]
                  )
                : _c("div", {
                    key: "w-alert-" + index,
                    staticClass: "alert alert-warning",
                    domProps: { innerHTML: _vm._s(warning) },
                  }),
            ]
          }),
          _vm._v(" "),
          _vm._l(_setup.state.errors, function (error, index) {
            return [
              error.heading
                ? _c(
                    "div",
                    { key: "e-card-" + index, staticClass: "mb-3 card" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "card-header bg-danger-subtle text-danger-emphasis d-flex align-items-center",
                        },
                        [
                          _c("i", {
                            staticClass: "bi bi-exclamation-octagon-fill me-2",
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: { innerHTML: _vm._s(error.heading) },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "card-body",
                        domProps: { innerHTML: _vm._s(error.message) },
                      }),
                    ]
                  )
                : _c(
                    "div",
                    {
                      key: "e-alert-" + index,
                      staticClass:
                        "alert alert-danger d-flex align-items-center",
                    },
                    [
                      _c("i", {
                        staticClass: "bi bi-exclamation-octagon-fill me-2",
                      }),
                      _vm._v(" "),
                      _c("span", { domProps: { innerHTML: _vm._s(error) } }),
                    ]
                  ),
            ]
          }),
          _vm._v(" "),
          _setup.state.rowCount
            ? _c(
                "div",
                { staticClass: "mt-4 text-center border-top pt-4" },
                [
                  _c("p", { staticClass: "fs-5" }, [
                    _c("b", [_vm._v(_vm._s(_setup.state.rowCount) + " rows")]),
                    _vm._v(" ready to import"),
                  ]),
                  _vm._v(" "),
                  _setup.state.errors.length || _setup.state.warnings.length
                    ? _c("p", { staticClass: "mb-3" }, [
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label",
                            attrs: { role: "button" },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _setup.state.ignoreErrorsAndWarnings,
                                  expression: "state.ignoreErrorsAndWarnings",
                                },
                              ],
                              staticClass: "form-check-input",
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(
                                  _setup.state.ignoreErrorsAndWarnings
                                )
                                  ? _vm._i(
                                      _setup.state.ignoreErrorsAndWarnings,
                                      null
                                    ) > -1
                                  : _setup.state.ignoreErrorsAndWarnings,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a =
                                      _setup.state.ignoreErrorsAndWarnings,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _setup.state,
                                          "ignoreErrorsAndWarnings",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _setup.state,
                                          "ignoreErrorsAndWarnings",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _setup.state,
                                      "ignoreErrorsAndWarnings",
                                      $$c
                                    )
                                  }
                                },
                              },
                            }),
                            _vm._v(
                              "\n                        Ignore errors and warnings\n                    "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    _setup.Button,
                    {
                      attrs: {
                        disabled: _setup.importBtnDisabled,
                        "default-class": "btn-warning btn-lg px-5",
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _setup.importData.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("\n                    Import\n                ")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }